<template>
  <TabComplexBase
    :text="text"
    :size="size"
    :draggable="draggable"
    :disabled="disabled"
    :active="active"
    :class="[
      style.tabStyle,
      active ? style.active : '',
      disabled ? style.disabled : ''
    ]"
    :actionHandler="actionHandler"
    :icon="icon"
    @drag-start="$emit('drag-start', $event)"
    @drag-end="$emit('drag-end', $event)"
  >
    <template v-if="$slots.default" #default>
      <slot />
    </template>
  </TabComplexBase>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "./TabComplex.module.scss";
import TabComplexBase from "@/elements/UI/tabs/TabComplex/TabComplexBase.vue";

export default defineComponent({
  name: "TabComplexStyle",

  components: {
    TabComplexBase
  },

  emits: ["drag-start", "drag-end"],

  props: {
    text: {
      type: String,
      default: ""
    },
    size: {
      type: String as PropType<Size>,
      default: "S"
    },
    icon: {
      type: String
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    },
    actionHandler: {
      type: Function,
      default: () => ({})
    }
  },

  data() {
    return {
      style
    };
  }
});
</script>
